<!-- Snackbar -->
@if (isSuccess() || hasError() || isLeaving()) {
  <div
    class="snackbar"
    [class.snackbar--success]="isSuccess()"
    [class.snackbar--error]="hasError()"
    [class.snackbar--leaving]="isLeaving()"
    role="alert"
    aria-live="polite"
  >
    @if (isSuccess()) {
      {{ translate.translations().form.successMessage }}
    }
    @if (hasError()) {
      {{ errorMessage() }}
    }
  </div>
}

<div class="contact-form">
  <h2 id="contact-form-title" class="sr-only">
    {{ translate.translations().form.contactForm }}
  </h2>

  <form
    class="contact-form__fields"
    aria-labelledby="contact-form-title"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    novalidate
  >
    <!-- Campo Nome -->
    <div class="contact-form__group">
      <label for="contact-name" class="contact-form__label">
        {{ translate.translations().form.name }}
        <span aria-hidden="true">{{
          translate.translations().form.required
        }}</span>
      </label>
      <input
        type="text"
        id="contact-name"
        class="contact-form__input"
        [class.contact-form__input--error]="isFieldInvalid('name')"
        placeholder="Ex: John Doe"
        autocomplete="name"
        formControlName="name"
        aria-required="true"
        [attr.aria-describedby]="isFieldInvalid('name') ? 'error-name' : null"
      />
      @if (isFieldInvalid("name")) {
        <span
          id="error-name"
          class="text-(--color-accent)! font-bold"
          role="alert"
        >
          {{ translate.translations().form.errorName }}
        </span>
      }
    </div>

    <!-- Campo E-mail -->
    <div class="contact-form__group">
      <label for="contact-email" class="contact-form__label">
        {{ translate.translations().form.email }}
        <span aria-hidden="true">{{
          translate.translations().form.required
        }}</span>
      </label>
      <input
        type="email"
        id="contact-email"
        class="contact-form__input"
        [class.contact-form__input--error]="isFieldInvalid('email')"
        placeholder="john@gmail.com"
        autocomplete="email"
        formControlName="email"
        aria-required="true"
        [attr.aria-describedby]="isFieldInvalid('email') ? 'error-email' : null"
      />
      @if (isFieldInvalid("email")) {
        <span
          id="error-email"
          class="text-(--color-accent)! font-bold"
          role="alert"
        >
          {{ translate.translations().form.errorEmail }}
        </span>
      }
    </div>

    <div class="contact-form__footer">
      <!-- Campo Mensagem -->
      <div class="contact-form__group contact-form__group--textarea">
        <label for="contact-message" class="contact-form__label">
          {{ translate.translations().form.message }}
          <span aria-hidden="true">{{
            translate.translations().form.required
          }}</span>
        </label>
        <textarea
          id="contact-message"
          class="contact-form__input contact-form__input--textarea"
          [class.contact-form__input--error]="isFieldInvalid('message')"
          [placeholder]="translate.translations().form.placeholder"
          rows="4"
          formControlName="message"
          aria-required="true"
          [attr.aria-describedby]="
            isFieldInvalid('message') ? 'error-message' : null
          "
        ></textarea>
        @if (isFieldInvalid("message")) {
          <span
            id="error-message"
            class="text-(--color-accent)! font-bold"
            role="alert"
          >
            {{ translate.translations().form.errorMessage }}
          </span>
        }
      </div>

      <app-button
        [isLink]="false"
        type="submit"
        [label]="
          isSubmitting()
            ? translate.translations().sending
            : translate.translations().send
        "
        [disabled]="isSubmitting()"
      />
    </div>
  </form>
</div>

<!-- Informações de contato -->
<div class="contact-info">
  <h3 id="contact-info-title" class="sr-only">
    {{ translate.translations().form.contactChannels }}
  </h3>
  <ul aria-labelledby="contact-info-title">
    <li class="contact-info__item">
      <a
        href="mailto:juliograffin@gmail.com"
        class="contact-info__link"
        aria-label="Enviar e-mail para juliograffin@gmail.com"
      >
        <i class="contact-info__icon icon-email" aria-hidden="true">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.3333 7.99928V13.8326C17.3333 14.7609 17.7021 15.6511 18.3585 16.3075C19.0149 16.9639 19.9051 17.3326 20.8333 17.3326C21.7616 17.3326 22.6518 16.9639 23.3082 16.3075C23.9646 15.6511 24.3333 14.7609 24.3333 13.8326V12.6659C24.3332 10.0328 23.4423 7.47717 21.8055 5.41456C20.1687 3.35196 17.8823 1.90371 15.3181 1.30529C12.7539 0.706874 10.0626 0.993491 7.68192 2.11854C5.30123 3.24358 3.37114 5.14089 2.20548 7.50195C1.03982 9.86301 0.707138 12.549 1.26154 15.1231C1.81594 17.6972 3.22482 20.008 5.25908 21.6799C7.29334 23.3518 9.83335 24.2863 12.4661 24.3316C15.0988 24.3769 17.6695 23.5302 19.76 21.9293M17.3333 12.6659C17.3333 15.2433 15.244 17.3326 12.6667 17.3326C10.0894 17.3326 8.00001 15.2433 8.00001 12.6659C8.00001 10.0886 10.0894 7.99928 12.6667 7.99928C15.244 7.99928 17.3333 10.0886 17.3333 12.6659Z"
              stroke="#DAE62C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </i>
        <span class="contact-info__text">juliograffin@gmail.com</span>
      </a>
    </li>

    <li class="contact-info__item">
      <a
        href="https://instagram.com/jotagraffin"
        target="_blank"
        rel="noopener noreferrer"
        class="contact-info__link"
      >
        <i class="contact-info__icon icon-instagram" aria-hidden="true">
          <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.0833 6.25H19.095M6.83333 1H18.5C21.7217 1 24.3333 3.61167 24.3333 6.83333V18.5C24.3333 21.7217 21.7217 24.3333 18.5 24.3333H6.83333C3.61167 24.3333 1 21.7217 1 18.5V6.83333C1 3.61167 3.61167 1 6.83333 1ZM17.3333 11.9317C17.4773 12.9026 17.3115 13.8943 16.8594 14.7655C16.4073 15.6368 15.692 16.3433 14.8152 16.7846C13.9385 17.2259 12.9449 17.3795 11.9757 17.2236C11.0066 17.0676 10.1114 16.6101 9.41731 15.916C8.72324 15.2219 8.26569 14.3267 8.10974 13.3576C7.9538 12.3885 8.10741 11.3949 8.54871 10.5181C8.99002 9.64133 9.69655 8.92603 10.5678 8.47395C11.4391 8.02187 12.4307 7.85602 13.4017 8C14.3921 8.14687 15.309 8.60837 16.017 9.31636C16.725 10.0243 17.1865 10.9413 17.3333 11.9317Z"
              stroke="#DAE62C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </i>
        <span class="contact-info__text">@jotagraffin</span>
      </a>
    </li>

    <li class="contact-info__item">
      <a
        href="https://linkedin.com/in/juliograffin"
        target="_blank"
        rel="noopener noreferrer"
        class="contact-info__link"
      >
        <i class="contact-info__icon icon-linkedin" aria-hidden="true">
          <svg
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.5833 7.25C17.2409 7.25 18.8307 7.90848 20.0028 9.08058C21.1749 10.2527 21.8333 11.8424 21.8333 13.5V20.7917H17.6667V13.5C17.6667 12.9475 17.4472 12.4176 17.0565 12.0269C16.6658 11.6362 16.1359 11.4167 15.5833 11.4167C15.0308 11.4167 14.5009 11.6362 14.1102 12.0269C13.7195 12.4176 13.5 12.9475 13.5 13.5V20.7917H9.33333V13.5C9.33333 11.8424 9.99181 10.2527 11.1639 9.08058C12.336 7.90848 13.9257 7.25 15.5833 7.25Z"
              stroke="#DAE62C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.16667 8.29167H1V20.7917H5.16667V8.29167Z"
              stroke="#DAE62C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3.08333 5.16667C4.23393 5.16667 5.16667 4.23393 5.16667 3.08333C5.16667 1.93274 4.23393 1 3.08333 1C1.93274 1 1 1.93274 1 3.08333C1 4.23393 1.93274 5.16667 3.08333 5.16667Z"
              stroke="#DAE62C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </i>
        <span class="contact-info__text">juliograffin</span>
      </a>
    </li>

    <li class="contact-info__item">
      <a
        href="https://github.com/jgraffin"
        target="_blank"
        rel="noopener noreferrer"
        class="contact-info__link"
      >
        <i class="contact-info__icon icon-github" aria-hidden="true">
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.95859 15.8334C2.41693 17.0834 2.41693 13.75 1.00026 13.3334M10.9169 18.3334V15.1084C10.9435 14.711 10.8979 14.3115 10.7831 13.9365C10.6683 13.5615 10.4869 13.2195 10.2511 12.9334C12.4753 12.6417 14.8128 11.65 14.8128 7.10003C14.8126 5.93655 14.4322 4.8177 13.7503 3.97503C14.0732 2.95712 14.0503 1.83199 13.6865 0.833363C13.6865 0.833363 12.8507 0.541696 10.9169 2.0667C9.29343 1.54905 7.58209 1.54905 5.95859 2.0667C4.02484 0.541696 3.18901 0.833363 3.18901 0.833363C2.82519 1.83199 2.80236 2.95712 3.12526 3.97503C2.43827 4.82395 2.05746 5.95292 2.06276 7.12503C2.06276 11.6417 4.40026 12.6334 6.62443 12.9584C6.39138 13.2417 6.21165 13.5795 6.09694 13.95C5.98222 14.3204 5.93508 14.7151 5.95859 15.1084V18.3334"
              stroke="#DAE62C"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </i>
        <span class="contact-info__text">jgraffin</span>
      </a>
    </li>

    <li class="contact-info__item contact-info__item--phone">
      <a
        href="https://wa.me/5541995052527"
        target="_blank"
        rel="noopener noreferrer"
        class="contact-info__link-phone"
      >
        <span class="sr-only">WhatsApp: </span>
        +55 41 99505 2527
      </a>
    </li>
  </ul>

  <p class="rights">&copy; {{ currentYear }} - Julio Graffin</p>
</div>
